<template>
    <div>
        <v-text-field
            v-model="period.title"
            label="Nama"
            autofocus
        ></v-text-field>

        Layanan
        <v-checkbox
            v-model="hasTryOut"
            label="Try out"
        ></v-checkbox>

        <v-checkbox
            v-model="hasContent"
            label="Konten"
        ></v-checkbox>
        <div v-if="hasContent">
            <content-editor
                v-model="content"
                label="Konten"
            ></content-editor>
        </div>

        <v-checkbox
            v-model="hasKelon"
            label="Video kelon"
        ></v-checkbox>
        <div v-if="hasKelon">
            Url video admin kelon
            <kelon-access-field
                v-model="period.kelonGroupId"
                class="mb-4"
            ></kelon-access-field>
        </div>

        <v-text-field
            v-model="period.slug"
            label="Nama Singkat"
            hint="Digunakan pada url pendaftaran"
            :rules="slugRules"
        ></v-text-field>

        <v-checkbox
            v-model="period.isActive"
            label="Aktif (Mengaktifkan pendaftaran)"
        ></v-checkbox>

        <v-checkbox
            v-model="period.isVisible"
            label="Tampilkan di homepage"
        ></v-checkbox>

        <v-checkbox
            v-model="period.isSpecific"
            label="Syarat pendaftaran khusus"
        ></v-checkbox>

        <v-text-field
            v-if="!period.isTrial"
            v-model="period.price"
            label="Harga"
        ></v-text-field>

        <v-textarea
            v-if="period.isVisible"
            v-model="period.description"
            label="Deskripsi di homepage"
        ></v-textarea>

        <v-textarea
            v-if="period.isSpecific"
            v-model="period.requirement"
            label="Syarat pendaftaran"
        ></v-textarea>
    </div>
</template>

<script>
import ContentEditor from './ContentEditor.vue'
import KelonAccessField from './KelonAccessField.vue'

const PERIOD_CONTACT_TRYOUT = 1
const PERIOD_CONTACT_TUTOR = 2

// spaghetti code, just for the v2, will rewrite in v3
export default {
    components: {
        ContentEditor,
        KelonAccessField,
    },

    data() {
        return {
            hasContent: false,
            hasTryOut: true,
            hasKelon: false,
            content: null,

            period: {
                title: null,
                isActive: true,
                isVisible: true,
                slug: null,
                isTrial: false,
                isSpecific: false,
                contactType: PERIOD_CONTACT_TRYOUT,
                price: null,
                description: null,
                requirement: null,
                kelonGroupId: null,
            },

            contactTypes: [
                { value: PERIOD_CONTACT_TRYOUT, text: 'Tryout' },
                { value: PERIOD_CONTACT_TUTOR, text: 'Bimbel' },
            ],

            slugRules: [
                (v) =>
                    /^[a-z0-9-]+$/.test(v) ||
                    'Hanya boleh berisi huruf kecil, angka, dan -',
            ],
        }
    },

    computed: {
        finalPeriodData() {
            return {
                ...this.period,
                is_content_registration:
                    (this.hasContent && !this.hasTryOut) ||
                    (this.hasKelon && !this.hasTryOut && !this.hasContent),
                content: this.serializedContent,
            }
        },

        serializedContent() {
            if (this.content) {
                return JSON.stringify(this.content)
            }

            return null
        },
    },

    watch: {
        period: {
            handler() {
                if (this.period.isTrial) {
                    this.price = 0
                }

                if (!this.hasContent) {
                    this.content = null
                }

                if (!this.hasKelon) {
                    this.period.kelonGroupId = null
                }

                this.$emit('input', this.finalPeriodData)
            },
            deep: true,
        },
    },
}
</script>
